import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export default function HigherJoinerFormDialog({ joiner = {}, onClose, onSaved }) {
  const isEdit = !!joiner.id;
  const [name, setName] = useState(joiner.name || "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (isEdit) await api.put(`/higher/joiners/${joiner.id}`, { name });
      else await api.post("/higher/joiners", { name });
      toast.success(isEdit ? "Higher Joiner renamed" : `${name.trim()} added to Higher Joiners`);
      onSaved();
      onClose();
    } catch (err) {
      toast.error(errMsg(err, "Couldn't save Higher Joiner"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="higher-joiner-form-dialog" className="bg-zinc-950 border-zinc-800 sm:rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{isEdit ? "Rename Higher Joiner" : "Add Higher Joiner"}</DialogTitle>
          <DialogDescription>They'll show on the Higher Store Claims page.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Joiner Name</Label>
            <Input data-testid="higher-joiner-name-input" required autoFocus maxLength={60} value={name} onChange={(e) => setName(e.target.value)} className="bg-zinc-900" />
          </div>
          <Button type="submit" disabled={busy || !name.trim()} data-testid="higher-joiner-save-button" className="w-full h-11 rounded-xl bg-white text-zinc-950 hover:bg-zinc-200 font-semibold">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{isEdit ? "Save" : "Add Higher Joiner"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
